module.exports = __webpack_public_path__ + "img/whatsapp.3a8dad7f.png";